import { animate, state, style, transition, trigger } from '@angular/animations';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RelatorioVendasService } from '../relatorio-vendas-service/relatorio-vendas.service';
import { ListaBase } from '../../../../shared/crud/ListaBase';
import { ExportExcelService } from '../../../../shared/excel-service/export-excel.service';

declare var $: any;

@Component({
  selector: 'app-relatorio-vendas-lista',
  templateUrl: './relatorio-vendas-lista.component.html',
  styleUrls: ['./relatorio-vendas-lista.component.css'],
  animations: [
    trigger('rowExpansionTrigger', [
      state('void', style({
        transform: 'translateX(-10%)',
        opacity: 0
      })),
      state('active', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ]
})
export class RelatorioVendasListaComponent extends ListaBase implements OnInit {
  itensMenu: any[] = ['TODOS', 'INDICADORES GERAIS', 'VENDAS COLLABORATION', 'LEADS', 'TEST DRIVE', 'CARRO USADO', 'MARGEM', 'FINANCIAMENTO', 'ESTOQUE'];
  itemMenuSelected: any = 'TODOS';
  visualizarTotalRegistros: boolean;
  exibirBotaoDetalhes: boolean;
  carregando: boolean;
  categorias: string[] = [];
  dealerFixo: String[] = ['Brasil'];
  dealers: string[] = ['IESA Caxias do Sul', 'IESA Porto Alegre'];
  marcas: string[] = [];
  modelo = [];
  dadosFamilia = [];
  public data: Array<any> = [];
  cacheDadosModelo = [];
  cols: any[]
  frozenCols: any[];
  headers: any[];

  detalhe = {
    descricao: 'Ver detalhado',
    icone: 'fa fa-calendar',
    acao: function () {
      this.router.navigateByUrl(this.obterUrlComFiltros(), { state: { modulo: 'relatorio-vendas' } });
    }.bind(this)
  }

  dados: string[] = [];

  totalGeral: any;

  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    legend: { display: false }
  };

  public barChartLabels: string[] = [];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartData: any[] = [];
  public barChartColors: any[] = [];

  parametrosFiltro: any;
  valoresMarcasOriginal;
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query
  PrimeiraMarcaLabel = '';
  SegundaMarcaLabel = '';
  PrimeiraMarca: boolean = true;
  SegundaMarca: boolean = true;

  constructor(service: RelatorioVendasService, toastr: ToastrService, router: Router, private exportExcel: ExportExcelService, private currency: CurrencyPipe, private percent: PercentPipe) {
    super(service, toastr, router);
    this.visualizarTotalRegistros = true;
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 5;
    this.exibirBotaoDetalhes = true;
    this.exibirBotaoNovo = false;
    this.nomeModulo = 'relatorio-vendas';
  }

  ngOnInit() {
    this.buscar();
    this.tableRelationships();
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  protected getDados(response: any): any {
    this.listaDados(response);
    return response;
  }

  public listaDados(data: any) {
    this.carregando = true
    this.data = data.produtos
    this.carregando = false
  }


  //************** Sublinha o label da marca no grafico quando o item fica desativado************* */
  toogleLabelJaguar() {
    $('.fontJaguar').toggleClass('active');
  }

  toogleLabelLandRover() {
    $('.fontLandRover').toggleClass('active');
  }

  /*************************************************************************************************/


  protected getListagemComFiltros(): boolean {
    return this.filtros.mercado
      || this.filtros.grupo_economico
      || this.filtros.regiao
      || this.filtros.regional
      || this.filtros.dealer
      || this.filtros.data_inicial
      || this.filtros.data_final;
  }

  public definirFiltragem() {
    $('#relatorio-vendas').modal();
  }


  voltar() {
    this.router.navigateByUrl(this.obterUrlComFiltros());
  }

  obterUrlComFiltros(): string {
    let url = '';
    return 'relatorio-vendas/detalhado' + url;
  }

  exportarExcel() {
    this.exportExcel.nomeModulo = this.nomeModulo;
    this.exportExcel.ExportTOExcel();
  }

  tableRelationships() {

    this.cols = [
      { field: 'nome', header: 'Produto', width: '20rem' },
      { field: 'objetivoVenda', header: 'Objetivo de Venda' },
      { field: 'vnfVarejo', header: 'VNF Varejo' },
      { field: 'vnfVenda', header: 'VNF Venda direta' },
      { field: 'totalVnf', header: 'Total VNF' },
      { field: 'faturadoVarejo', header: 'FAT. Varejo' },
      { field: 'faturadoVenda', header: 'FAT. Venda direta' },
      { field: 'totalFaturado', header: 'Total Faturado' },
      { field: 'totalVarejo', header: 'VNF + FAT Varejo' },
      { field: 'totalVendaDireta', header: 'VNF + FAT Venda direta' },
      { field: 'totalVnfFaturado', header: 'Total VNF + Faturado' },
      { field: 'percentualObjetivoVenda', header: '% O.V. Alcançado', type: this.percent, arg2: '1.0-0' },
      { field: 'fluxoShowroom', header: 'Fluxo S. R.' },
      { field: 'percentualVendaShowroom', header: '% Vendas S. R.', type: this.percent, arg2: '1.0-0' },
      { field: 'fluxoShowroomOficina', header: 'Fluxo S. R. Oficina' },
      { field: 'vendaOficina', header: 'Vendas Oficina' },
      { field: 'percentualVendaOficina', header: '% Vendas Fluxo Oficina', type: this.percent, arg2: '1.0-0' },
      { field: 'percentualColaboration', header: '% Collaboration', type: this.percent, arg2: '1.0-0' },
      { field: 'quantidadeLead', header: 'Qtd. Leads' },
      { field: 'vendaOriginadaLead', header: 'Vendas Originadas Leads' },
      { field: 'percentualConversaoLead', header: '% Conversão Leads', type: this.percent, arg2: '1.0-0' },
      { field: 'percentualContribuicaoLead', header: '% Contribuição Leads', type: this.percent, arg2: '1.0-0' },
      { field: 'testeDriveRealizado', header: 'Test Drives Realizados' },
      { field: 'conversaoTestdriveShowroom', header: 'Conversão Test Drive V.S. Fluxo S.R.' },
      { field: 'percentualTradeIn', header: '% Trade In', type: this.percent, arg2: '1.0-0' },
      { field: 'valorMedioCarroUsado', header: 'Valor Médio Carro Usado' },
      { field: 'valorMedioNfFabricaDealer', header: 'Valor Médio NF Fabrica → Dealer', type: this.currency, arg1: " " },
      { field: 'valorMedioNfDealerCliente', header: 'Valor Médio NF Dealer → Cliente', type: this.currency, arg1: " " },
      { field: 'margemMediaLucro', header: 'Margem Média Lucro $', type: this.currency, arg1: " " },
      { field: 'percentualMargemMediaLucro', header: '%Margem Média Lucro', type: this.percent, arg2: '1.0-0' },
      { field: 'quantidadeCarroFinanciado', header: 'Qtd. Carros Financiados' },
      { field: 'percentualVendaFinanciada', header: '% Vendas Financiados', type: this.percent, arg2: '1.0-0' },
      { field: 'quantidadeCarroFinanciadoBanco', header: 'Qtd. Carros Financiados Banco Volvo' },
      { field: 'percentualPenetracaoBanco', header: '% Penetração Banco Volvo', type: this.percent, arg2: '1.0-0' },
      { field: 'quantidadeMediaParcelas', header: 'Qntd. Média de Parcelas' },
      { field: 'percentualMedioEntrada', header: '% Médio de Entrada', type: this.percent, arg2: '1.0-0' },
      { field: 'quantidadeCarroEstoque', header: 'Qntd. Carros Em Estoque' },
      { field: 'tempoMedioEstoque', header: 'Tempo Médio de Estoque' },
      { field: 'tempoMedioSuprimento', header: 'Qtd. de Dias Médio de Suprimento', color: '#FF0000' }
    ];


    this.headers = [
      { header: 'INDICADORES GERAIS - VENDAS', colspan: 17, width: '350rem' },
      { header: 'VENDAS COLLABORATION', colspan: 1, width: '15rem' },
      { header: 'LEADS', colspan: 4, width: '60rem' },
      { header: 'TEST DRIVE', colspan: 2, width: '30rem' },
      { header: 'CARRO USADO', colspan: 2, width: '35rem' },
      { header: 'MARGEM', colspan: 4, width: '65rem' },
      { header: 'FINANCIAMENTO', colspan: 6, width: '99rem' },
      { header: 'ESTOQUE', colspan: 3, width: '60rem' }
    ];
    

    this.frozenCols = [
      { field: 'nome', header: 'Produto' }
    ];
  }
}
